// THE public display score of a pro (Founder 01/10/26: "החישוב הצגה באתר ילקח בחשבון מספר פניות + מספר קידום"):
//   rank_score = inquiries received (lib/proTrack PRO_INQUIRIES_SQL — non-test tickets only) + he_professionals.promotion_points
// Higher score = higher on EVERY public list (category /<cat>, city /<cat>/<city>, questionnaire matches, WA routing, search,
// homepage strip, AMP via getProfessionals). The previous order stays as the tie-breaker. On a city list the same-city tier
// (Founder 28/09 law) still comes first — the score orders INSIDE it and among the radius-matched rest (lib/proMatching).
// Ranking only REORDERS; it never adds a pro to a city/category (supply rules untouched). Promotion = admin "קידום" field.
// Isomorphic (strings + a pure fn, no DB import) so client components can rank too. Needs the pro table aliased `p`.
import { PRO_INQUIRIES_SQL } from './proTrack';

export const PROMOTION_SQL = `COALESCE(p.promotion_points, 0)`;
export const RANK_SCORE_SQL = `(${PRO_INQUIRIES_SQL} + ${PROMOTION_SQL})`;
/** Select-list fragment: `promotion_points`, `rank_score`. */
export const RANK_SCORE_SELECT_SQL = `${PROMOTION_SQL} AS promotion_points, ${RANK_SCORE_SQL} AS rank_score`;
/** ORDER BY prefix — `ORDER BY ${RANK_ORDER_SQL}p.rating DESC`. */
export const RANK_ORDER_SQL = `${RANK_SCORE_SQL} DESC, `;

export type RankScoreInput = {
  rankScore?: number | string | null; rank_score?: number | string | null;
  inquiriesReceived?: number | string | null; inquiries_received?: number | string | null;
  promotionPoints?: number | string | null; promotion_points?: number | string | null;
};
/** JS twin of RANK_SCORE_SQL for rows that already carry the parts. */
export function rankScore(p: RankScoreInput): number {
  const s = p.rankScore ?? p.rank_score;
  if (s != null && s !== '') return Number(s) || 0;
  return (Number(p.inquiriesReceived ?? p.inquiries_received ?? 0) || 0) + (Number(p.promotionPoints ?? p.promotion_points ?? 0) || 0);
}
/** Stable sort by score DESC — keeps the incoming order between equal scores. */
export function sortByRankScore<T extends RankScoreInput>(rows: T[]): T[] {
  return rows.map((p, i) => ({ p, i, s: rankScore(p) })).sort((a, b) => (b.s - a.s) || (a.i - b.i)).map(x => x.p);
}
